/**
 * Interim GS event types (CT-5091+). Kept in a leaf module (imports nothing) so
 * both utils/mapSourceToEvent.js and constants/eventTypes.js can share the same
 * source of truth without a circular import. These strings are intentionally NOT
 * in EVENT_TYPE — unregistered types fall back to the generic body until the
 * unified HTL events endpoint (CT-4867) ships.
 */
export const INTERIM_EVENT_TYPE = {
  CHANGE_REQUEST: 'change_request',
  PROPOSAL: 'proposal',
  CLAIM_SUGGESTION: 'claim_suggestion',
  TASK: 'task',
};
